import { render, staticRenderFns } from "./busquedaPasaporte.vue?vue&type=template&id=3036bd7c&scoped=true"
import script from "./busquedaPasaporte.vue?vue&type=script&lang=js"
export * from "./busquedaPasaporte.vue?vue&type=script&lang=js"
import style0 from "./busquedaPasaporte.vue?vue&type=style&index=0&id=3036bd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036bd7c",
  null
  
)

export default component.exports